import React, { Component } from "react";
import { Link } from "react-router-dom";

import PhotoTaskSlider from "../../component/PhotoTaskSlider";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { PRIORITY } from "../../config/const";
import { TAKS_REVIEW } from "../../config/lang";

import { dateFormat, reviewTaskPoint, reviewMerchandiserNamePhone, reviewTaskSupervisor } from "../../util/formatter";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";

import "./style.scss";

const me = getStore().getState().me;

class TaskReviewDetails extends Component {
  state = { fullscreenPhoto: null, fullscreenIndex: null };

  openFullscreen = (index) => {
    this.setState({ fullscreenPhoto: this.props.item.photos[index], fullscreenIndex: index });
  };

  closeFullscreen = () => {
    this.setState({ fullscreenPhoto: null, fullscreenIndex: null });
  };

  lightboxPrev = (e) => {
    e.stopPropagation();
    const { fullscreenIndex } = this.state;
    const photos = this.props.item.photos;
    const newIndex = fullscreenIndex - 1;
    if (newIndex >= 0) this.setState({ fullscreenPhoto: photos[newIndex], fullscreenIndex: newIndex });
  };

  lightboxNext = (e) => {
    e.stopPropagation();
    const { fullscreenIndex } = this.state;
    const photos = this.props.item.photos;
    const newIndex = fullscreenIndex + 1;
    if (newIndex < photos.length) this.setState({ fullscreenPhoto: photos[newIndex], fullscreenIndex: newIndex });
  };

  componentDidMount = () => {
    let { acceptRejectAnswer, passTaskToModal, moveNext } = this.props;
    const closeFullscreen = () => this.closeFullscreen();
    const handleArrow = (dir) => {
      if (this.state.fullscreenPhoto) {
        const { fullscreenIndex } = this.state;
        const photos = this.props.item.photos;
        const newIndex = fullscreenIndex + dir;
        if (newIndex >= 0 && newIndex < photos.length)
          this.setState({ fullscreenPhoto: photos[newIndex], fullscreenIndex: newIndex });
      } else {
        moveNext(dir);
      }
    };

    document.addEventListener("keydown", function(e) {
      switch (e.keyCode) {
        case 27:
          closeFullscreen();
          break;
        case 37:
          handleArrow(-1);
          break;
        case 39:
          handleArrow(+1);
          break;
        case 38:
          acceptRejectAnswer("ACCEPT");
          break;
        case 40:
          passTaskToModal();
          break;
      }
    });
  };

  render() {
    let { item, acceptRejectAnswer, passTaskToModal, activePhotoIndex } = this.props;
    const { fullscreenPhoto, fullscreenIndex } = this.state;
    const task = item.task;
    const tags = item.selected_tags;
    return (
      <div className="ar-details">
        {fullscreenPhoto && (
          <div className="ar-photo-lightbox" onClick={this.closeFullscreen}>
            <button className="ar-photo-lightbox__close" onClick={this.closeFullscreen}>
              <i className="fa fa-times" />
            </button>
            {fullscreenIndex > 0 && (
              <button className="ar-photo-lightbox__nav ar-photo-lightbox__nav--prev" onClick={this.lightboxPrev}>
                <i className="fa fa-chevron-circle-left" />
              </button>
            )}
            <img
              src={fullscreenPhoto.photo_url}
              className="ar-photo-lightbox__img"
              onClick={(e) => e.stopPropagation()}
            />
            {fullscreenIndex < item.photos.length - 1 && (
              <button className="ar-photo-lightbox__nav ar-photo-lightbox__nav--next" onClick={this.lightboxNext}>
                <i className="fa fa-chevron-circle-right" />
              </button>
            )}
          </div>
        )}
        <div className="ar-layout">
          <div className="ar-photo-card">
            <h3 className="ar-card-title">
              <span className="material-symbols-outlined">photo_library</span>
              {translate(TAKS_REVIEW, "photo_title", me.language)}
            </h3>
            <div className="ar-photo-canvas">
              {item.photos.length > 0 ? (
                <PhotoTaskSlider activePhotoIndex={activePhotoIndex} photos={item.photos} viewMode="group" clickCallback={this.openFullscreen} />
              ) : (
                item.photo && <img src={item.photo} className="ar-preview-img" />
              )}
            </div>
          </div>

          <div className="ar-info-col">
            <div className="ar-card">
              <h3 className="ar-card-title">
                <span className="material-symbols-outlined">assignment</span>
                {translate(TAKS_REVIEW, "details_task", me.language)}
              </h3>

              <div className="ar-fields-grid">
                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "title_task", me.language)}</span>
                  <span className="ar-field-value">{task?.title || "—"}</span>
                </div>

                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "point", me.language)}</span>
                  <span className="ar-field-value">{reviewTaskPoint("", item)}</span>
                </div>

                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "priority", me.language)}</span>
                  <span className="ar-field-value">{task && PRIORITY[task.priority]}</span>
                </div>

                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "deadline_task", me.language)}</span>
                  <span className="ar-field-value">{task && dateFormat(task.end)}</span>
                </div>

                <div className="ar-field ar-field--full">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "description_task", me.language)}</span>
                  <span className="ar-field-value">{task?.description || "—"}</span>
                </div>

                {task?.tags?.length > 0 && (
                  <div className="ar-field ar-field--full">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "tags_task", me.language)}</span>
                    <div className="ar-tags">
                      {task.tags.map((t, index) => (
                        <span key={index} className="ar-tag">{t.name}</span>
                      ))}
                    </div>
                  </div>
                )}

                {task?.images?.length > 0 && (
                  <div className="ar-field ar-field--full">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "images_task", me.language)}</span>
                    <div className="ar-image-links">
                      {task.images.map((img, index) => (
                        <a key={index} href={img.image} target="_blank" className="ar-image-link">
                          <span className="material-symbols-outlined">image</span>
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="ar-card">
              <h3 className="ar-card-title">
                <span className="material-symbols-outlined">chat_bubble</span>
                {translate(TAKS_REVIEW, "details_response_task", me.language)}
              </h3>

              <div className="ar-fields-grid">
                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "merchandiser", me.language)}</span>
                  <span className="ar-field-value">{reviewMerchandiserNamePhone("", item)}</span>
                </div>

                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "supervisor", me.language)}</span>
                  <span className="ar-field-value">{reviewTaskSupervisor("", item)}</span>
                </div>

                <div className="ar-field">
                  <span className="ar-field-label">{translate(TAKS_REVIEW, "date_response_task", me.language)}</span>
                  <span className="ar-field-value">{dateFormat(item.created)}</span>
                </div>

                {item.answer && (
                  <div className="ar-field ar-field--full">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "text_response_task", me.language)}</span>
                    <span className="ar-field-value">{item.answer}</span>
                  </div>
                )}

                {item.photo && (
                  <div className="ar-field">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "photo_response_task", me.language)}</span>
                    <a href={item.photo} target="_blank" className="ar-image-link">
                      <span className="material-symbols-outlined">image</span>
                    </a>
                  </div>
                )}

                {item.boolean_answer !== null ? (
                  <div className="ar-field ar-field--full">
                    <div className="ar-boolean-group">
                      <span className="ar-boolean-option">
                        {item?.boolean_answer ? <RadioButtonCheckedIcon color={"info"} /> : <RadioButtonUncheckedIcon color={"info"} />}
                        {translate(TAKS_REVIEW, "yes", me.language)}
                      </span>
                      <span className="ar-boolean-option">
                        {!item?.boolean_answer ? <RadioButtonCheckedIcon color={"info"} /> : <RadioButtonUncheckedIcon color={"info"} />}
                        {translate(TAKS_REVIEW, "no", me.language)}
                      </span>
                    </div>
                  </div>
                ) : null}

                {item.visit && (
                  <div className="ar-field">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "visit_id", me.language)}</span>
                    <span className="ar-field-value">
                      <Link to={"visit/" + item.visit.id} target="_blank" className="ar-link">
                        #{item.visit.id}
                      </Link>
                    </span>
                  </div>
                )}

                {tags && tags.length > 0 && (
                  <div className="ar-field ar-field--full">
                    <span className="ar-field-label">{translate(TAKS_REVIEW, "tags_task", me.language)}</span>
                    <div className="ar-tags">
                      {tags.map((t, index) => (
                        <span key={index} className="ar-tag">{t}</span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {!item.is_supervised && (
              <div className="ar-actions">
                <button className="ar-action-btn ar-action-btn--accept" onClick={() => acceptRejectAnswer("ACCEPT")}>
                  <span className="material-symbols-outlined">check_circle</span>
                  {translate(TAKS_REVIEW, "apply_btn", me.language)}
                </button>
                <button className="ar-action-btn ar-action-btn--reject" onClick={passTaskToModal}>
                  <span className="material-symbols-outlined">cancel</span>
                  {translate(TAKS_REVIEW, "reject_btn", me.language)}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export { TaskReviewDetails };
